import React from 'react'
import { Img } from './styles'
import logoIcon from '../../../assets/imgs/logoCicomBranca.svg'

function Logo() {
  return <Img src={logoIcon} />
}

export { Logo }
